// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"484":"8e9b54cd6abcd05a0650","921":"4264d6e8e80054ec787b"}[chunkId] + ".js";
};